// src/components/Footer.js
import React, { useEffect } from "react";
import "../CSS/Footer.css";

export default function Footer() {
  useEffect(() => {
    const el = document.getElementById("site-footer");
    if (!el) return;
    const setH = () =>
      document.documentElement.style.setProperty("--footer-h", `${el.offsetHeight}px`);
    setH();
    if ("ResizeObserver" in window) {
      const ro = new ResizeObserver(setH);
      ro.observe(el);
      return () => ro.disconnect();
    }
    window.addEventListener("resize", setH);
    return () => window.removeEventListener("resize", setH);
  }, []);

  return (
    <footer id="site-footer" className="footer">
      <div className="f-wrap">
        <div className="brandline" />
        <div className="f-main">
          <div className="brand">
            <span className="u-name">Universidad Técnica de Manabí</span>
            <span className="u-slogan">Formando profesionales con excelencia y compromiso</span>
          </div>
          <div className="meta">© {new Date().getFullYear()} · Todos los derechos reservados</div>
        </div>
      </div>
    </footer>
  );
}
